import { UserModels } from '@project44-models/iam-gateway';

import { Exception } from '../../../../shared/abstract/domain/Exception';

export class DeactivatedUserTenantSpecificRolesException extends Exception {
  constructor(public readonly user?: UserModels.UserViewModel) {
    super(
      `Cannot fetch tenant specific roles on a User that is deactivated: ${user?.lakeId}'`,
    );
  }

  public static throw(user?: UserModels.UserViewModel): never {
    throw new DeactivatedUserTenantSpecificRolesException(user);
  }
}
